import { gql } from '@apollo/client';
import list from './List';
import show from './Show';
import edit from './Edit';

export default {
  name: 'QualificationAttributes',
  inputShow: gql`
    query QualificationAttributes($input: QualificationAttributeQueryInput) {
      qualificationAttributes(input: $input) {
        data
        field_type
        id
        name
        required
        slug
        __typename
      }
    }
  `,
  list,
  show,
  edit,
  // create,
  options: {
    group: 'Qualifications',
    label: 'Qualification Attributes',
  },
};
